export default function () {
    this.conf.offCanvas.page.noSelector.push('#olark');
}
;



//////////////////
// WEBPACK FOOTER
// ../~/mmenu-js/dist/wrappers/olark/mmenu.olark.js
// module id = 111
// module chunks = 0